import AbstractView = require("./abstract/AbstractView");
import YTPlayer = require("../media/YTPlayer");
import Config = require("../config/Config");


class ProductView extends AbstractView {

    constructor(id: number, selector: JQuery) {
        super(id, selector);
    }

    init(): void {

        if (Config.device === "mobile") {
        }

        this.mainVideoBtn = this.$template.find(".mainVideoBtn");
        this.mainVideoBtn.addClass("active");

        this.createYTVideo();
        this.createVideoBtn();
    }


    private ytPlayer: YTPlayer;
    private mainVideoBtn: JQuery;
    private createYTVideo(): void {
        this.ytPlayer = new YTPlayer("ytPlayer-loop", "0VvU6eVrmpE", true, true, false);
        this.ytPlayer.emitter.on(YTPlayer.VideoEvent.PLAYER_READY, () => {
        });
        this.ytPlayer.emitter.on(YTPlayer.VideoEvent.ON_PLAYING, () => {
            // console.log("Youtube is Playing");
            this.mainVideoBtn.removeClass("active");
        });
    }

    private createVideoBtn(): void {

        let btnTotal: number = this.$template.find(".video-btn").length;
        for (let i: number = 0; i < btnTotal; i++) {
            let videoBtn: JQuery = this.getChildBySelector(".video-btn:eq(" + i + ")");
            videoBtn.on("click tap", (event: JQuery.Event) => {
                event.preventDefault();
                this.emitter.emit(ProductView.ViewEvent.PlayVideo, videoBtn.data("video"));
                // this.$template.trigger("PLAY_VIDEO", [videoBtn.data("video")]);
            });
        }
    }
}

export = ProductView;